import {Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle} from '@/components/ui';
import {cn} from '@/lib/utils';
import {ReactNode, useRef} from 'react';

type Props = {
  title?: string,
  children: ReactNode,
  className?: string,
  onClose?: () => void,
  onLoad?: (node: HTMLDivElement) => void,
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl',
  contentProps?: any,
  modal?: boolean,
  focusNone?: boolean
}

const getContentProps = (props: any) => {
  return {
    onPointerDownOutside: (e: any) => {
      if (document.body.classList.contains('loading')) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    onEscapeKeyDown: (e: any) => {
      if (document.body.classList.contains('loading')) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    ...props,
  };
};

const ADialog = ({
                   title = '',
                   children,
                   onClose,
                   className,
                   onLoad,
                   size = 'md',
                   contentProps,
                   modal,
                   focusNone
                 }: Props
) => {
  const firstRender = useRef(false);
  return (
    <Dialog open={true} onOpenChange={(open) => {
      if (!open && onClose) {
        onClose();
      }
    }} modal={modal}>
      <DialogContent
        className={cn('app-dialog overflow-y-auto max-h-screen ', `size-${size}`, className)}
        ref={(node) => {
          if (node && !firstRender.current) {
            firstRender.current = true;
            if (onLoad && node) {
              onLoad(node);
            }
            if (focusNone) {
              const elementsCollection = document.getElementsByClassName('app-dialog');
              if (elementsCollection.length > 0) {
                const element = elementsCollection[0] as HTMLDivElement;
                element.focus();
              }
            }
          }
        }}
        {...getContentProps(contentProps)}
      >
        {title && (
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
            <DialogDescription className="hidden">{title}</DialogDescription>
          </DialogHeader>
        )}
        {children}
      </DialogContent>
    </Dialog>
  );
};

export {ADialog};